import { getLocalUser } from "./localStorage"

export const isUserProfileCompleted = () => {
    const user = getLocalUser()
    if (user.first_name && user.last_name && user.job) {
        return true
    }
    return false
}
